import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { TimelineConstants } from '../../timeline/store/timeline.constants'
import { IItem } from '../../timeline/store/timeline.types'
import { IEKGEvent } from '../store/ekgImport.types'
import { IExtricationState } from '../../procedures/extrication/store/extrication.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { INemsisSnomedLookup } from '../../../components/procedure/store/procedure.types'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../utilities/nemsisCode.util'

interface CreateExtricationProcedureProps {
  procedureEvent: IEKGEvent
  ptaCutoff: Date | null
  nemsisCodeOptions: INemsisSnomedLookup[]
}

export interface ExtricationProcedureObject {
  timelineItem: IItem
  extricationState: IExtricationState
}

const createExtricationProcedure = (props: CreateExtricationProcedureProps): ExtricationProcedureObject => {
  const { procedureEvent, ptaCutoff, nemsisCodeOptions } = props

  const clientEventId = (procedureEvent.eventVitals.clientEventId as number).toString()
  const vsAction = procedureEvent.eventVitals.vsAction
  const isEkgImport = procedureEvent.eventVitals.isEkgImport

  const itemComments = procedureEvent.procedureComments || ''
  const itemSubHeader = `By , Attempts: 1, Success: Yes, Comments: ${itemComments}.`

  const eventDate = new Date(procedureEvent.dtDevice)
  const isPTA = !!ptaCutoff && eventDate < ptaCutoff

  const clientCorrelationId = generateClientCorrelationId(
    nemsisCodeOptions,
    TimelineConstants.EXTRICATION_PROCEDURE,
    null,
    {
      filter1: null,
      filter2: null,
      filter3: null,
    },
    clientEventId
  )
  const timelineItem: IItem = {
    key: clientEventId,
    clientCorrelationId,
    itemType: 'Procedures',
    event: 'Extrication',
    grid: true,
    labelHeaderFlag: isPTA ? 'PTA' : '',
    labelHeader: procedureEvent.eventVitals.time,
    subHeader: procedureEvent.eventVitals.date,
    eventSubHeader: itemSubHeader,
    rowActionType: TimelineConstants.SET_EXTRICATION_PROCEDURE_ITEM,
    defaultHref: TabConstants.EXTRICATION_PROCEDURE,
    date: new Date(procedureEvent.dtDevice),
    clientEventId: clientEventId,
    ...(vsAction && { vsAction: vsAction }),
    ...(isEkgImport && { isEkgImport: isEkgImport }),
  }

  let extricationState: IExtricationState = {
    key: clientEventId,
    date: procedureEvent.eventVitals.date,
    time: procedureEvent.eventVitals.time,
    assessedBy: null,
    procedureComplications: [],
    response: null,
    responsePNNV: null,
    authorization: null,
    comments: itemComments,
    addToTimeline: false,
    updateInputRows: false,
    successfulAttempt: true,
    pta: isPTA,
    attempts: '1',
    type: 'Extrication',
    rolePerforming: null,
    rolePerformingPNNV: null,
    isEkgImport: 1,
    nemsisCode: null,
    procedurePerformedByAnotherUnit: null,
    procedurePerformedByAnotherUnitPNNV: null,
  }

  try {
    extricationState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: extricationState,
      actionField: (s) => s.method.name,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    extricationState = handleNemsisCodeError(error, extricationState)
  }

  const extricationProcedureObject: ExtricationProcedureObject = {
    extricationState,
    timelineItem,
  }

  return extricationProcedureObject
}

export default createExtricationProcedure
